import { config } from "../models/config";

/**
 * The auth headers EVERY REST client must send.
 *
 * `authorization` carries the real bearer when there is one (oidc/edge). In the local "dev" bypass
 * there is no token; `X-Dev-User` tells the backend's dev filter which demo persona to answer as.
 *
 * Sending that header from ONE client only was a trap: the SDUI transport switched persona while
 * accountApi/projectApi/eqmsApi/downloadsApi were still answered as the default `kim`, so changing
 * `devUser` in `public/env.js` moved the titlebar name but not the data — and the screens gated on a
 * workspace-admin or platform-admin identity (워크스페이스 관리, 관리자) could not be reached in a plain
 * browser at all. Every client builds its headers here now, so one `devUser` switch moves everything.
 */
export function authHeaders(getToken: () => string | null): Record<string, string> {
  const token = getToken();
  return {
    ...(token ? { authorization: `Bearer ${token}` } : {}),
    ...(config.authMode === "dev" ? { "X-Dev-User": config.devUser } : {}),
  };
}

/** {@link authHeaders} plus a JSON content type — what the typed clients' `call()` helpers send. */
export function jsonHeaders(getToken: () => string | null): Record<string, string> {
  return { "content-type": "application/json", ...authHeaders(getToken) };
}
